import { useLocation, useHistory, Redirect } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { useAppDispatch } from '../redux';
import { completeInvoicePayment } from '../features/InvoicePayment/InvoicePaymentSlice';
import { getSafeInvoiceDetailsPath } from '../utils/invoiceUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export function PayInvoicePage() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(location.search);
  const paymentUrl = params.get('url');
  const invoiceDetailsPath = getSafeInvoiceDetailsPath(params.get('invoiceDetailsPath'), window.location.origin);
  const invoiceNumber = params.get('invoiceNumber');
  const breadcrumbs = [{
    label: 'payInvoice.breadcrumb.invoices',
    href: Paths.INVOICES
  }, ...(invoiceDetailsPath ? [{
    label: invoiceNumber ? 'invoiceDetails.breadcrumb.invoiceNumber' : 'invoiceDetails.breadcrumb.invoiceDetails',
    href: invoiceDetailsPath,
    options: invoiceNumber ? {
      invoiceNumber
    } : undefined
  }] : []), {
    label: 'payInvoice.breadcrumb.payInvoice'
  }];
  if (!paymentUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.INVOICES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: paymentUrl,
    title: "Pay Invoice",
    breadcrumbs: breadcrumbs,
    subscreen: "pay-invoice",
    onMessage: msg => {
      if (msg.payload.type === 'SUCCESS' || msg.payload.type === 'SUCCESS_WITH_REDIRECT') {
        dispatch(completeInvoicePayment());
        history.push(Paths.INVOICES);
      }
    }
  });
}